import { Skeleton } from "@/components/ui/skeleton";

const DietBuilderSkeleton = () => {
  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      {/* Header */}
      <div>
        <Skeleton className="h-8 w-48 mb-2" />
        <Skeleton className="h-4 w-72" />
      </div>

      {/* Calorie Counter Card */}
      <div className="bg-card rounded-2xl p-5 shadow-card border border-border">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            <Skeleton className="w-10 h-10 rounded-xl" />
            <div>
              <Skeleton className="h-3 w-24 mb-2" />
              <Skeleton className="h-6 w-36" />
            </div>
          </div>
          <div className="text-right space-y-1">
            <Skeleton className="h-4 w-10 ml-auto" />
            <Skeleton className="h-3 w-16 ml-auto" />
          </div>
        </div>
        <Skeleton className="w-full h-2.5 rounded-full" />
      </div>

      {/* Meal Blocks */}
      {[1, 2, 3, 4].map(i => (
        <div key={i} className="bg-card rounded-2xl shadow-card border border-border">
          <div className="flex items-center justify-between p-5">
            <div className="flex items-center gap-2">
              <Skeleton className="w-7 h-7 rounded" />
              <div>
                <Skeleton className="h-5 w-28 mb-1" />
                <Skeleton className="h-3 w-36" />
              </div>
            </div>
            <Skeleton className="w-5 h-5 rounded" />
          </div>
          {i <= 2 && (
            <div className="px-5 pb-5 space-y-4">
              <div className="flex gap-2">
                <Skeleton className="h-8 w-24 rounded-lg" />
                <Skeleton className="h-8 w-16 rounded-lg" />
              </div>
              <Skeleton className="w-full h-1.5 rounded-full" />
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {[1, 2, 3, 4].map(j => (
                  <Skeleton key={j} className="h-28 rounded-xl" />
                ))}
              </div>
            </div>
          )}
        </div>
      ))}

      {/* Bottom Button */}
      <div className="sticky bottom-20 md:bottom-4">
        <Skeleton className="w-full h-11 rounded-md" />
      </div>
    </div>
  );
};

export default DietBuilderSkeleton;
